import {mapValueKeys} from '@shared/helpers/object'

import {DeliveryFeeClass, DeliveryFeePay, DeliveryMethod} from '@web/core/constants'
import {DeliveryGroupState} from '@web/slices/deliveryGroup/slice'
import makeSlice from '@web/slices/deliveryGroup/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'
import {Delivery} from '../../apis/response/interface/delivery'

function convertDeliveryGroupsByKey(
    deliveryGroupsByKey: Delivery['deliveryGroupsByKey'],
): DeliveryGroupState['deliveryGroupsByKey'] {
    return mapValueKeys((deliveryGroupItem) => {
        return {
            additionalDeliveryFee: deliveryGroupItem.additionalDeliveryFee,
            deliveryFee: deliveryGroupItem.exposureDeliveryFee ?? deliveryGroupItem.deliveryFee,
            deliveryFeePayType: deliveryGroupItem.deliveryFeePayType ?? DeliveryFeeClass.FREE,
            deliveryFeeDiscountAmount: null,
            deliveryPolicy: {
                baseFee: deliveryGroupItem.deliveryFee,
                deliveryArea2ExtraFee: null,
                deliveryArea3ExtraFee: null,
                deliveryAreaType: null,
                deliveryFeeClassType:
                    deliveryGroupItem.deliveryFeePayType === DeliveryFeeClass.FREE
                        ? DeliveryFeeClass.FREE
                        : DeliveryFeeClass.CHARGE,
                deliveryFeePayType: deliveryGroupItem.deliveryFeePayType ?? DeliveryFeePay.FREE,
                deliveryMethodType: deliveryGroupItem.deliveryMethodType ?? DeliveryMethod.DELIVERY,
                freeConditionalAmount: null,
                repeatQuantity: null,
                secondBaseQuantity: null,
                secondExtraFee: null,
                thirdBaseQuantity: null,
                thirdExtraFee: null,
                additionalFeeMessage: null,
            },
        }
    }, deliveryGroupsByKey)
}

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {delivery} = payload.data
            state.deliveryGroupsByKey = convertDeliveryGroupsByKey(delivery.deliveryGroupsByKey)
        })
    },
})

export default slice.reducer
